import React from 'react';
import Framework from '@beardeddevops/react.framework';
import SidenavContent from './SidenavContent';
import PropTypes from "prop-types";
import UserRoles from "../../constants/UserRoles";

const FrameworkSideBar = Framework.Components.withRootState(Framework.Components.SideBar);

export default class Sidebar extends React.Component {
	static propTypes = {
		regions: PropTypes.array,
		roles: PropTypes.array
	};

	componentDidMount() {

	}

	render() {
		const isMobile = window.innerWidth <= 768;
		let props = this.props;
		return (
			<FrameworkSideBar
				footerLink={"https://karlstechnology.freshdesk.com"}
				clickOutside={false}
				closeOnInit={this.props.roles.some(role => [UserRoles.FieldEngineer, UserRoles.Onboarding].includes(role)) || (this.props.roles.some(role => [UserRoles.Admin].includes(role)) && isMobile)}
				{...props}
			>
				<SidenavContent {...props} />
			</FrameworkSideBar>


			/*<nav className='app-sidebar bg-color-dark no-print'>
				<section className='sidebar-header bg-color-dark' data-cy='main_logo'>

				</section>

				<section className="sidebar-content">

				</section>

				<section className="sidebar-footer">
					<ul className="nav">
						<li>
							<a target="_blank" href={}>
								<i className="nav-icon material-icons">help</i>
								<span className="nav-text"><span>Help</span> & <span>Support</span></span>
							</a>
						</li>
					</ul>
				</section>
			</nav>*/
		);
	}
}

